import { symptoms } from '@mummssoftware/utils/hope';

/** Progress-note addendum text for a completed SIA (symptom scores). */
export const getSIANote = (
  SIAmessage: string,
  SIAData: mumms.SIADTO | Record<string, unknown>,
  questionNumber: string,
  currentMilestone: string,
) => {
  const SIAEntries = Object.entries(SIAData);
  const SIAValues: string[] = SIAEntries.map((symptomData: any) => {
    const symptom = symptoms[symptomData[0]] || [];
    return `${symptom[0]}. ${symptom[1]}: ${symptomData[1]}`;
  });
  const textValues = SIAValues.join('\n');

  return `Addendum\n\u2022 ${currentMilestone} ${questionNumber} - ${SIAmessage}\n${textValues}`;
};

/** Args for persisting HOPE milestone / refused attrs and SFVRQ to PIM. */
export type PersistHopeVisitAttributesArgs = {
  /** User accepted (true) or declined (false) this HOPE milestone for the visit. */
  isHopeVisit: boolean | null;
  stateSIA?: Record<string, unknown>;
  /** Open SIA modal after a successful save (e.g. first accept). */
  openSIAOnSave?: boolean;
};
